module.exports = __webpack_public_path__ + "static/media/computer-projects.62691098.jpg";